module.exports = __webpack_public_path__ + "img/recharge_go-zh.48526d32.png";